import $ from 'jquery'

function scrollToHash() {
  const {hash} = window.location

  if (!/#[\w-_]+/.test(hash)) {
    return
  }

  const $tabsList = $('#tabs-category-detail').closest('section')
  const $targetEl = $(hash)

  if (!$tabsList.length || !$targetEl.length) {
    return
  }

  const $tabsLinks = $tabsList.find('li')
  let $tabPane = $targetEl.hasClass('tab-pane') ? $targetEl : $targetEl.closest('.tab-pane')

  if ($tabPane.length) {
    const paneId = $tabPane[0].id
    const $targetTab = $tabsList.find(`a[href="#${paneId}"]`)

    // open the required tab
    if ($targetTab.length && !$tabPane.hasClass('active') && parseInt($tabsList[0].dataset.genesCount)) {
      $tabPane.siblings().removeClass('active')
      $tabPane.addClass('active')

      $tabsLinks.removeClass('active')
      $targetTab.parent().addClass('active')
    }
  }

  let scrollY = $targetEl.offset().top - 88

  // open required content dropdown
  if ($targetEl.hasClass('category-content')) {
    const $link = $targetEl.prev()
    if ($link.hasClass('collapsed')) {
      $link.click()
    }
  }

  // take letters links panel height into account
  if (/-genes$/.test($targetEl[0].id)) {
    scrollY -= 80
  }

  if ('scrollTo' in window) {
    window.scrollTo({top: scrollY, behavior: 'smooth'})
  } else {
    $('html, body').animate({scrollTop: scrollY}, 300)
  }

  // disable scroll restoration in modern browsers
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}

export {scrollToHash}
